import React, { createContext, useCallback, useContext, useEffect, useState } from 'react'

// Site-wide reading-language preference (English / Hindi). Static HTML always
// renders English; the saved choice is applied after hydration.
const STORAGE_KEY = 'tos-lang'
export const SITE_LANGUAGES = ['en', 'hi']

const LanguageContext = createContext({ lang: 'en', setLang: () => {} })

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState('en')

  useEffect(() => {
    try {
      const saved = window.localStorage.getItem(STORAGE_KEY)
      if (SITE_LANGUAGES.indexOf(saved) !== -1) setLangState(saved)
    } catch (e) {}
  }, [])

  const setLang = useCallback(next => {
    if (SITE_LANGUAGES.indexOf(next) === -1) return
    setLangState(next)
    try {
      window.localStorage.setItem(STORAGE_KEY, next)
    } catch (e) {}
  }, [])

  return (
    <LanguageContext.Provider value={{ lang, setLang }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
